// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file quanterix/simoa_one/analysis_app_api/v1/experiment_config.proto (package quanterix.simoa_one.analysis_app_api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { AssayData } from "./assay_data_pb";
import { file_quanterix_simoa_one_analysis_app_api_v1_assay_data } from "./assay_data_pb";
import type { ExperimentParameterOverrides } from "./experiment_parameter_overrides_pb";
import { file_quanterix_simoa_one_analysis_app_api_v1_experiment_parameter_overrides } from "./experiment_parameter_overrides_pb";
import type { PlateWellConfig } from "./plate_well_config_pb";
import { file_quanterix_simoa_one_analysis_app_api_v1_plate_well_config } from "./plate_well_config_pb";
import type { SampleMetadata } from "./sample_metadata_pb";
import { file_quanterix_simoa_one_analysis_app_api_v1_sample_metadata } from "./sample_metadata_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file quanterix/simoa_one/analysis_app_api/v1/experiment_config.proto.
 */
export const file_quanterix_simoa_one_analysis_app_api_v1_experiment_config: GenFile = /*@__PURE__*/
  fileDesc("Cj9xdWFudGVyaXgvc2ltb2Ffb25lL2FuYWx5c2lzX2FwcF9hcGkvdjEvZXhwZXJpbWVudF9jb25maWcucHJvdG8SJ3F1YW50ZXJpeC5zaW1vYV9vbmUuYW5hbHlzaXNfYXBwX2FwaS52MSLzAwoQRXhwZXJpbWVudENvbmZpZxIaCg1leHBlcmltZW50X2lkGAEgASgJSACIAQESHwoSaW5zdHJ1bWVudF9kYXRhX2lkGAIgASgJSAGIAQESQgoGYXNzYXlzGAMgAygLMjIucXVhbnRlcml4LnNpbW9hX29uZS5hbmFseXNpc19hcHBfYXBpLnYxLkFzc2F5RGF0YRJICgdzYW1wbGVzGAQgAygLMjcucXVhbnRlcml4LnNpbW9hX29uZS5hbmFseXNpc19hcHBfYXBpLnYxLlNhbXBsZU1ldGFkYXRhElQKEnBsYXRlX3dlbGxfY29uZmlncxgFIAMoCzI4LnF1YW50ZXJpeC5zaW1vYV9vbmUuYW5hbHlzaXNfYXBwX2FwaS52MS5QbGF0ZVdlbGxDb25maWcScgoeZXhwZXJpbWVudF9wYXJhbWV0ZXJfb3ZlcnJpZGVzGAYgASgLMkUucXVhbnRlcml4LnNpbW9hX29uZS5hbmFseXNpc19hcHBfYXBpLnYxLkV4cGVyaW1lbnRQYXJhbWV0ZXJPdmVycmlkZXNIAogBAUIQCg5fZXhwZXJpbWVudF9pZEIVChNfaW5zdHJ1bWVudF9kYXRhX2lkQiEKH19leHBlcmltZW50X3BhcmFtZXRlcl9vdmVycmlkZXNiBnByb3RvMw", [file_quanterix_simoa_one_analysis_app_api_v1_assay_data, file_quanterix_simoa_one_analysis_app_api_v1_experiment_parameter_overrides, file_quanterix_simoa_one_analysis_app_api_v1_plate_well_config, file_quanterix_simoa_one_analysis_app_api_v1_sample_metadata]);

/**
 * Represents the configuration of an experiment for analysis, i.e.
 * all required inputs for performing analysis, including assays used,
 * plate layout assignments, and instrument data references
 *
 * @generated from message quanterix.simoa_one.analysis_app_api.v1.ExperimentConfig
 */
export type ExperimentConfig = Message<"quanterix.simoa_one.analysis_app_api.v1.ExperimentConfig"> & {
  /**
   * Unique id (UUID) of the experiment associated with this configuration
   *
   * @generated from field: optional string experiment_id = 1;
   */
  experimentId?: string;

  /**
   * Unique id (UUID) of the instrument data associated with this experiment
   *
   * @generated from field: optional string instrument_data_id = 2;
   */
  instrumentDataId?: string;

  /**
   * The set of assays under test in this experiment configuration
   *
   * @generated from field: repeated quanterix.simoa_one.analysis_app_api.v1.AssayData assays = 3;
   */
  assays: AssayData[];

  /**
   * Sample set under test in this experiment configuration
   *
   * @generated from field: repeated quanterix.simoa_one.analysis_app_api.v1.SampleMetadata samples = 4;
   */
  samples: SampleMetadata[];

  /**
   * Configuration of plate wells in this experiment, i.e. assay, sample, and
   * instrument data assignments
   *
   * @generated from field: repeated quanterix.simoa_one.analysis_app_api.v1.PlateWellConfig plate_well_configs = 5;
   */
  plateWellConfigs: PlateWellConfig[];

  /**
   * Setup, analysis, and / or post-processing parameters that have been
   * overridden from their default values in the context of this experiment
   *
   * @generated from field: optional quanterix.simoa_one.analysis_app_api.v1.ExperimentParameterOverrides experiment_parameter_overrides = 6;
   */
  experimentParameterOverrides?: ExperimentParameterOverrides;
};

/**
 * Describes the message quanterix.simoa_one.analysis_app_api.v1.ExperimentConfig.
 * Use `create(ExperimentConfigSchema)` to create a new message.
 */
export const ExperimentConfigSchema: GenMessage<ExperimentConfig> = /*@__PURE__*/
  messageDesc(file_quanterix_simoa_one_analysis_app_api_v1_experiment_config, 0);

